import React from 'react';


export default ({
  input,
  label,
  type,
  meta: { touched, error, warning }
}) => (
  <div>
    <textarea {...input}
      className={(touched && error && "textarea-error") || undefined} />
  </div>
);



// WEBPACK FOOTER //
// ./src/application-form/field-components/textarea.js